SC.home = (function () {
  var api = {};

  if ($('.swiper-slide').length > 1) {
    // eslint-disable-next-line no-unused-vars
    var swiper = new Swiper('.swiper-container', {
      autoplay: 5000,
      centeredSlides: true,
      loop: true,
      autoplayDisableOnInteraction: false,
      speed: 400,
      slidesPerView: 1
    });
  }

  // for homepage version with video
  $('.homepage video').click(function (e) {
    // get click position
    var clickY = (e.pageY - $(this).offset().top);
    var height = parseFloat( $(this).height() );

    // avoids interference with controls
    if (clickY > 0.82 * height) return;

    // toggles play / pause
    if (typeof InstallTrigger === 'undefined') {
      this.paused ? this.play() : this.pause();
    }
  });

  return api;
})();
